import React from "react";
import Flagship from "../../core/flagship";
import { Dropdown, Icon, Label } from "semantic-ui-react";
import { throttle, empty } from "../../utils/helpers";

class AdvisrClientField extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onReset = this.onReset.bind(this);
    this.setInputRef = this.setInputRef.bind(this);
    this.focusUserInput = this.focusUserInput.bind(this);

    this.userInput = null;
    this.preventFocus = this.props.preventFocus;

    this.focusUserInput = this.focusUserInput.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  getInitialState() {
    return {
      searchResults: [],
      emptySearch: false,
      clientId:this.props.value,
      focused: !this.props.preventFocus,
      expanded: !empty(this.props.expanded) ? this.props.expanded : true,
    };
  }

  componentDidMount() {
    if (this.preventFocus !== true) {
      this.focusUserInput();
    }

  }

  focusUserInput() {
    if (this.userInput) {
      this.userInput.focus();
    }
  }

  setInputRef(element) {
    this.userInput = element;
  }

  searchAdvisrClients(like) {
    let self = this;

    let params = {
      search: like,
    };

    if (empty(this.props.limitInstance)) {
      params["instance"] = this.props.limitInstance;
    }


    Flagship.get(
      "dropdown-search/advisr_client",
      params,
      function (response) {
        if (response.data.success === true) {
          self.setState({
            searchResults: response.data.results.map((res) => ({value:res.id, text:`${res.name} (${res.id})`})),
            emptySearch:
              empty(response.data.results) ||
              response.data.results.length === 0,
          });
        } else {
          Flagship.error(
            "Could not retrieve dropdown search results for user field. Query: " +
              like,
            0,
            0
          );
        }
      },
      function (err) {
        Flagship.error("An error occurred in dropdown search: " + err, 0, 0);
      }
    );
  }

  onChange(e, data) {

    this.setState(
      {
        clientId: data.value
      },
      function () {
        if (typeof this.props.onChange === "function") {
          this.props.onChange(e, data);
        }
      }
    );
  }

  onSearchChange(e, data) {
    this.props.onChange(null, { value: false });

    let search = this.searchAdvisrClients.bind(this);
    this.timer = throttle(
      function () {
        search(data);
      },
      700,
      this.timer
    );
  }

  onReset() {
    let self = this;
    this.preventFocus = false;
    this.setState(
      {
        clientId:null,
        focused: true,
      },
      function () {
        self.focusUserInput();
        if (typeof self.props.onReset === "function") {
          self.props.onReset();
        }
      }
    );
  }

  handleFocus() {
    this.setState({
      focused: true,
    });
  }

  handleBlur() {
    this.setState({
      focused: false,
    });
  }

  toggleExpanded() {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    return (
      <div>
        {this.props.label ? (
          <Label className="single-field-label user-field-label" size="large">
            {this.props.label}
            {this.props.required === "1" ||
            this.props.required === true ||
            this.props.required === 1 ? (
              <Icon
                color="red"
                size="tiny"
                className="asterisk"
                name="asterisk"
              />
            ) : null}
          </Label>
        ) : null}

        <Dropdown
          className="advisr-search"
          fluid
          search
          openOnFocus
          searchInput={{ autoFocus: !this.preventFocus }}
          placeholder="Search by name..."
          selection
          text={`${this.state.clientId}`}
          noResultsMessage="No Advisr clients found by this name."
          label={this.props.label}
          onChange={this.onChange}
          onSearchChange={this.onSearchChange.bind(this)}
          options={this.state.searchResults}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          value={this.state.clientId}
        />
        {this.props.allowDelete && this.state.clientId !== null ? (
          <Icon
            circular
            style={{
              cursor: "pointer",
              marginTop: ".25em",
              marginLeft: ".25em",
            }}
            className="user-field-delete"
            name="delete"
            color="red"
            onClick={this.onReset}
          />
        ) : null}
        {this.state.emptySearch === true ? (
          <div>
            <br />
            No matching Advisr clients found.
          </div>
        ) : this.state.focused === true ? (
          <div>
            <br />
            <br />
          </div>
        ) : null}
      </div>
    );
  }
}

export default AdvisrClientField;



// WEBPACK FOOTER //
// ./src/components/misc/AdvisrClientField.js